import React, {Component} from 'react';

class IconWarning extends Component {
  render() {
    return (<i className="emoji">
      <svg className="emoji" viewBox="-8 -8 64 64" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path style={{fill:"#FFEEA3"}} d="M3.209,35.5c-0.617,0-1.169-0.319-1.477-0.853c-0.309-0.534-0.309-1.172,0-1.706L18.523,3.858
		c0.308-0.534,0.86-0.853,1.477-0.853s1.169,0.319,1.477,0.853l16.791,29.083c0.309,0.534,0.309,1.171,0,1.706
		c-0.308,0.534-0.86,0.853-1.477,0.853H3.209z"></path>
  <path style={{fill:"#BA9B48"}} d="M20,3.506c0.209,0,0.73,0.059,1.044,0.603l16.791,29.083c0.314,0.544,0.105,1.025,0,1.206
		C37.73,34.578,37.419,35,36.791,35H3.209c-0.628,0-0.94-0.422-1.044-0.603c-0.105-0.181-0.314-0.662,0-1.206L18.956,4.109
		C19.27,3.564,19.791,3.506,20,3.506 M20,2.506c-0.743,0-1.486,0.368-1.91,1.103L1.299,32.691C0.45,34.162,1.511,36,3.209,36h33.582
		c1.698,0,2.759-1.838,1.91-3.309L21.91,3.609C21.486,2.873,20.743,2.506,20,2.506L20,2.506z"></path>
        </g>
        <circle style={{fill:"#36404D"}} cx="20" cy="29.214" r="1.696"></circle>
        <rect x="18.643" y="12.929" style={{fill:"#36404D"}} width="2.714" height="12.214"></rect>
      </svg>
    </i>)
  }
};

export default IconWarning;



// WEBPACK FOOTER //
// ./src/style/icon/IconWarning.js